import { createSelector } from 'reselect';
import { selectHasAdNetworkOrAgencyTaggedDataRestrictions } from '../../../../main/selectors/AccessControlSelectors';

export const selectDisableOrganicToggle = createSelector(
  selectHasAdNetworkOrAgencyTaggedDataRestrictions,
  // biome-ignore lint/correctness/noUnusedVariables: ignored using `--suppress`
  (state, props) => props.disableOrganicToggle,
  (hasAdNetworkOrAgencyTaggedDataRestrictions, disableOrganicToggle) => {
    if (hasAdNetworkOrAgencyTaggedDataRestrictions) {
      return true;
    }

    return disableOrganicToggle;
  }
);
